import { BonCommandeReference } from './bonCommandeReference';
import { BonCommandeService } from './bonCommandeService';
import { Region } from './region';

export class BonCommande {
	id: number;
	marche: string;
	description: string;
	lot: string;
	descriptionLot: string;
	commande: string;
	dateDebut: string;
	dateFin: string;
	responsable: string;
	adjudicateur: string;
	adresseFacturation: string;
	titulaire: string;
	references: BonCommandeReference[];
	region: Region;
	services: BonCommandeService[];
	nombreHeuresPrevisionnelUtil: number;

	constructor(
		options: {
			id?: number;
			marche?: string;
			description?: string;
			lot?: string;
			descriptionLot?: string;
			nombreHeuresPrevisionnelUtil?: number;
		} = {}
	) {
		this.id = options.id || 0;
		this.marche = options.marche || null;
		this.description = options.description || null;
		this.lot = options.lot || null;
		this.descriptionLot = options.descriptionLot || null;
		this.nombreHeuresPrevisionnelUtil = options.nombreHeuresPrevisionnelUtil || 0;
	}
	
}

export enum CibleString {
	EEPUB = 'En emploi public',
	EEPRIV = 'En emploi privé',
	EF = "Vers l'emploi",
}

export enum Cible {
	'EEPUB' = 'EEPUB',
	'EEPRIV' = 'EEPRIV',
	'EF' = 'EF',
}
